import { createSlice, PayloadAction } from '@reduxjs/toolkit'

type WsStatus = 'disconnected' | 'connecting' | 'connected' | 'error'

interface WsState {
  status: WsStatus
  url: string | null
  lastError: string | null
  activeSubId: string | null
}

const initialState: WsState = {
  status: 'disconnected',
  url: null,
  lastError: null,
  activeSubId: null,
}

const wsSlice = createSlice({
  name: 'ws',
  initialState,
  reducers: {
    wsConnecting(state, action: PayloadAction<{ url: string }>) {
      state.status = 'connecting'
      state.url = action.payload.url
      state.lastError = null
    },
    wsConnected(state) {
      state.status = 'connected'
      state.lastError = null
    },
    wsDisconnected(state) {
      state.status = 'disconnected'
      state.activeSubId = null
    },
    wsError(state, action: PayloadAction<{ message: string }>) {
      state.status = 'error'
      state.lastError = action.payload.message
    },
    wsSetActiveSub(state, action: PayloadAction<{ subId: string | null }>) {
      state.activeSubId = action.payload.subId
    },
  },
})

export const { wsConnecting, wsConnected, wsDisconnected, wsError, wsSetActiveSub } = wsSlice.actions
export default wsSlice.reducer

